import { Component, EventEmitter, Injector, Input, Output } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { AppComponentBase } from "@shared/app-component-base";
import { AnexarPrescricaoDialogComponent } from "./anexar-prescricao/anexar-prescricao-dialog.component";
import { AnexoConsultaDto, ConsultaDto, PedidoDto, TipoUsuarioEnum, UpdateConsultaDto } from "@shared/service-proxies/service-proxies";
import { SolicitarExameDialogComponent } from "./solicitar-exame/solicitar-exame-dialog.component";
import { ModalVisualizarAnexosComponent } from "@shared/components/default-consultas/modal-visualizar-anexos/modal-visualizar-anexos.component";

@Component({
    selector: 'exames-prescricoes',
    templateUrl: './exames-prescricoes.component.html',
    styleUrls: ['./exames-prescricoes.component.scss'],
})
export class ExamesPrescricoesComponent extends AppComponentBase {
    @Input() consulta: ConsultaDto;
      @Output() onRefresh = new EventEmitter<any>();
    

    constructor(
        injector: Injector,
        private readonly _modalService: BsModalService,
    ) { super(injector) }

    get pedidos(): PedidoDto[] {
        return this.consulta.pedidos ?? [];
    }

    get anexos(): AnexoConsultaDto[] {
        return this.consulta.anexos ?? [];
    }

    solicitarExame() {
        const anexosModal = this._modalService.show(
            SolicitarExameDialogComponent,
            {
                class: 'modal-md',
                ignoreBackdropClick: true,
                initialState: {
                    consulta: this.consulta
                }
            }
        );
        anexosModal.content.onSave.subscribe(() => {
            this.onRefresh.emit();
        });
    }

    anexarPrescricao() {
        const anexosModal = this._modalService.show(
            AnexarPrescricaoDialogComponent,
            {
                class: 'modal-md',
                ignoreBackdropClick: true,
                initialState: {
                    consulta: this.consulta
                }
            }
        );
        anexosModal.content.onSave.subscribe(() => {
            this.onRefresh.emit();
        });
    }

    anexarArquivo() {
        const anexosModal = this._modalService.show(
            ModalVisualizarAnexosComponent,
            {
                class: 'modal-md',
                ignoreBackdropClick: true,
                initialState: {
                    consulta: UpdateConsultaDto.fromJS(this.consulta.toJSON()),
                }
            }
        );
        anexosModal.content.onSave.subscribe(() => {
            this.onRefresh.emit();
        });
    }

    get exibirOpcoes(): boolean {
        return this.appSession.user.tipoUsuarioEnum === TipoUsuarioEnum._2;
    }
}
